import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

import StudentHomePage from '@/pages/StudentHomePage';
import MentorProfilePage from '@/pages/MentorProfilePage';
import StudentSetupPage from '@/pages/StudentSetupPage';
import StudentForgotPage from '@/pages/StudentForgotPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminOverviewPage from '@/pages/AdminOverviewPage';
import AdminBookingsPage from '@/pages/AdminBookingsPage';
import AdminMentorsPage from '@/pages/AdminMentorsPage';
import AdminStudentsPage from '@/pages/AdminStudentsPage';
import AdminFeedbackFormPage from '@/pages/AdminFeedbackFormPage';
import AdminFeedbackSubmissionsPage from '@/pages/AdminFeedbackSubmissionsPage';
import AdminUsersPage from '@/pages/AdminUsersPage';
import AdminSettingsPage from '@/pages/AdminSettingsPage';
import MentorOnboardingPage from '@/pages/MentorOnboardingPage';
import MentorOnboardingResultPage from '@/pages/MentorOnboardingResultPage';
import MentorFeedbackPage from '@/pages/MentorFeedbackPage';
import RequireAdmin from '@/components/RequireAdmin';

function App() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <BrowserRouter>
                <Routes>
                    {/* Student flow */}
                    <Route path="/" element={<StudentHomePage />} />
                    <Route path="/mentors/:mentorId" element={<MentorProfilePage />} />
                    <Route path="/student/setup" element={<StudentSetupPage />} />
                    <Route path="/student/forgot" element={<StudentForgotPage />} />
                    <Route path="/dashboard" element={<Navigate to="/" replace />} />

                    {/* Mentor links */}
                    <Route path="/mentor-onboarding/:mentorId" element={<MentorOnboardingPage />} />
                    <Route path="/mentor-onboarding/success" element={<MentorOnboardingResultPage status="success" />} />
                    <Route path="/mentor-onboarding/error" element={<MentorOnboardingResultPage status="error" />} />
                    <Route path="/mentor/feedback/:bookingId" element={<MentorFeedbackPage />} />

                    {/* Admin */}
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route path="/admin" element={<RequireAdmin section="overview"><AdminOverviewPage /></RequireAdmin>} />
                    <Route path="/admin/bookings" element={<RequireAdmin section="bookings"><AdminBookingsPage /></RequireAdmin>} />
                    <Route path="/admin/mentors" element={<RequireAdmin section="mentors"><AdminMentorsPage /></RequireAdmin>} />
                    <Route path="/admin/students" element={<RequireAdmin section="students"><AdminStudentsPage /></RequireAdmin>} />
                    <Route path="/admin/feedback-form" element={<RequireAdmin section="feedback_form"><AdminFeedbackFormPage /></RequireAdmin>} />
                    <Route path="/admin/feedback-submissions" element={<RequireAdmin section="feedback_submissions"><AdminFeedbackSubmissionsPage /></RequireAdmin>} />
                    <Route path="/admin/users" element={<RequireAdmin superOnly><AdminUsersPage /></RequireAdmin>} />
                    <Route path="/admin/settings" element={<RequireAdmin section="settings"><AdminSettingsPage /></RequireAdmin>} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
